// extracted by mini-css-extract-plugin
export default {"iconWrapper":"BUL_y6O"};